import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-type-product-nature.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsTypeProductNatureDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consTypeProductNatureEntity = useAppSelector(state => state.consTypeProductNature.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consTypeProductNatureDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consTypeProductNature.detail.title">ConsTypeProductNature</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consTypeProductNatureEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consTypeProductNature.code">Code</Translate>
            </span>
          </dt>
          <dd>{consTypeProductNatureEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consTypeProductNature.name">Name</Translate>
            </span>
          </dt>
          <dd>{consTypeProductNatureEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consTypeProductNature.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{consTypeProductNatureEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.consTypeProductNature.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{consTypeProductNatureEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consTypeProductNature.status">Status</Translate>
            </span>
          </dt>
          <dd>{consTypeProductNatureEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-type-product-nature" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-type-product-nature/${consTypeProductNatureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsTypeProductNatureDetail;
